/* Editor html usado https://ckeditor.com/docs/ckeditor4/latest/guide/dev_react.html */

import React, { Component } from 'react';
import Select from 'react-select';
import { Row, Col, Popover, OverlayTrigger } from "react-bootstrap";
import { toast } from 'react-toastify';

import CKEditor from 'ckeditor4-react';

import { CustomCard } from "../../components/Card/CustomCard";
import { Guardar } from "../../funciones/PublicacionesFunction";

/* CKEditor.editorUrl = 'https://cdn.ckeditor.com/4.12.1/full/ckeditor.js'; */
CKEditor.editorUrl = 'ckeditor/ckeditor.js';

class MainPublicaciones extends Component {
    state = {
        boton1: {
            icon: "fa fa-share-alt",
            text: "Publicar"
        },
        quien: { value: '', label: '- ¿Quién puede ver esto? -' },
        quienes: [
            {value: 1, label: "Todos"},
            {value: 2, label: "Solo yo"},
            {value: 3, label: "Directivos"},
            {value: 4, label: "Profesores"},
            {value: 5, label: "Estudiantes"},
            {value: 6, label: "Directivos y Profesores"},
            {value: 7, label: "Profesores y Estudiantes"},
            {value: 8, label: "Directivos y Estudiantes"}
        ],
        titulo: "",
        cantErrores: "",
        contentState: "",
    }

    constructor(props) {
        super(props);
    }


    valorQuien = (quien) => { this.setState({ quien }) }
    cambiaValor = (prop) => (event) => { this.setState({ [prop]: event.target.value.toUpperCase() }) };
    cambiaHtml = (e) => {
        this.setState( {
            contentState: e.editor.getData()
        } );
    }

    editorHTML = () => {
        return (
            <CKEditor
                data={this.state.contentState}
                type="classic"
                onChange={this.cambiaHtml} 
            />
        )
    }

    respuestaGuardar = (resp) => {
        let mensaje = resp[1];
        let errores = resp[2];
        let nameErrores = resp[3]
        let contentErr = [];

        let erroresList = (
            <Popover bsSize="large" title="Errores Encontrados" id="erroresList">
                {contentErr}
            </Popover>
        )

        let messOk = (mensaje) => {
            this.setState({
                boton1: {
                    icon: "fa fa-share-alt",
                    text: "Publicar"
                },
            }, () => {
                toast[mensaje.status](mensaje.mensaje,{autoClose: 4000});
            })
        }

        for (let i in nameErrores) {
            if (nameErrores[i] !== "") contentErr.push(
                <div key = {i} className="text-danger" style={{fontSize:10, marginBottom:8}}><i className="fa fa-exclamation-triangle"></i> {nameErrores[i]}</div>
            )
        }

        if (errores === 0) {
            this.setState({ cantErrores:"" })
        }
        if (mensaje[0].status === "error" && errores !== 0) this.setState ({
            cantErrores: <div style={{paddingTop:10}}>
                            Se han encontrado {errores} error(es). Haz click <span>
                            <OverlayTrigger trigger="focus" placement="top" overlay={erroresList}>
                                <button style={{borderWidth: 1}} className="btn btn-danger btn-xs">Aqui</button> 
                            </OverlayTrigger></span> para verlos
                        </div>
        })

        messOk(mensaje[0]);
    }

    guardarPub = () => {
        let { titulo, quien, contentState } = this.state;
        const campos = { titulo, quien, contentState }

        this.setState({
            boton1: {
                icon: "fa fa-spinner fa-spin",
                text: "Espera"
            },
        }, () => {
            Guardar (campos, (resp) => { this.respuestaGuardar(resp) })
        })
    }

    contenido = () => {
        let { boton1, quien, quienes, cantErrores, titulo } = this.state;
        const customStyles = (base) => ({
            ...base,
            fontSize: 12,
            zIndex: 100
        });

        return(
            <Row>
                <Col md={12} className="custom-mt-10">
                    <div className="custom-alert-warning">
                        <i class="fa fa-share-alt" aria-hidden="true"></i> Título del Artículo
                        <div>
                            <input type="text" className="form-control" value={titulo} onChange={this.cambiaValor("titulo")}/>
                            <div style={{fontSize: 10}}>Ingresa el título de la publicación</div>
                        </div>   
                    </div>
                </Col>
                <Col md={12} className="custom-mt-10">
                    <div className="custom-alert-info">
                        <Row>
                            <Col md={6} style={{marginTop: 10}}>
                                <i class="fa fa-share-alt" aria-hidden="true"></i> Contenido
                            </Col>
                            <Col md={6}>
                                <Select
                                    styles={{menu: customStyles}}
                                    isSearchable ={true}
                                    value={quien}
                                    onChange={this.valorQuien}
                                    options={quienes}
                                />
                            </Col>
                        </Row>
                    </div>
                </Col>
                <Col md={12} className="custom-mt-10">
                    {this.editorHTML()}
                </Col>
                <Col md={9} align="left" className="custom-mt-10">
                    <div className="text-danger">{ cantErrores }</div>
                </Col>
                <Col md={3} align="right" className="custom-mt-10">
                    <button className="btn btn-primary" onClick={this.guardarPub} style={{borderWidth: 1}}><i className={boton1.icon}></i> {boton1.text}</button>
                </Col>
            </Row>
        )
    }

    ayuda = () => (
        <Row>
            <Col md={12} align="justify">
                En esta sección puedes añadir publicaciones que aparecerán en el muro de cada usuario (dependiendo con quien compartas dicha información). Aparecerá la fecha y el nombre de la persona que escribe el artículo
            </Col>
            <Col md={12} align="justify" className="custom-mt-10">
                Para añadir una nueva publicación debes ingresar el título y el contenido del artículo, además de indicar con quien vas a compartir la publicación entre las opciones disponibles en el campo ¿Quién puede ver esto?
            </Col>
            <Col md={12} className="custom-mt-10">
                <strong style={{color:"#1f2f6e"}}>Título del Artículo</strong>
            </Col>
            <Col md={12} align="justify">
                Aqui debes ingresar un título acorde a la información que estas añadiendo
            </Col>
            <Col md={12} className="custom-mt-10">
                <strong style={{color:"#1f2f6e"}}>Contenido</strong>
            </Col>
            <Col md={12} align="justify">
                En esta área puedes ingresar contenido diverso (texto, imágenes, vínculos de otras páginas, videos) por lo que debes tener cuidado de lo que ingreses en esta área.
            </Col>
            <Col md={12} align="justify" className="custom-mt-10">
                Para esto cuentas con una barra de herramientas que te permitirán añadir el contenido a tu publicación (Cambiar el tamaño de letra, el color, el interlineado, etc.)
            </Col>
            <Col md={12} className="custom-mt-10">
                Para culminar el proceso haz click en el botón <button className="btn btn-primary btn-xs" style={{borderWidth: 1}}><i class="fa fa-share-alt" aria-hidden="true"></i> Publicar</button>
            </Col>
        </Row>
    )
    
    render() { 
        return (
            <div className="content">
                <Row>
                    <Col md={8}>
                        <div className="custom-alert-info" style={{padding:10}}>
                            <i className="fa fa-share-square-o"></i> Crear una nueva publicación
                        </div>
                        <div style={{borderRadius: "4px 4px", marginTop:10}}>
                            <CustomCard
                                title="Publicaciones"
                                category=""
                                color="#a80012"
                                content={this.contenido()}
                            />
                        </div>
                    </Col>
                    <Col md={4}>
                        <div style={{borderRadius: "4px 4px",}}>
                            <CustomCard
                                styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                                title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                                category={<span style={{color: "#fff"}}>Publicaciones</span>}
                                color="#a80012"
                                content={this.ayuda()}
                            />
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}
 
export default MainPublicaciones;


// WEBPACK FOOTER //
// ./src/views/Publicaciones/MainPublicaciones.jsx